import http from '../../../../libs/http'
import config from '../../../../config/shops'
export default (payload = {}) => http.put(`${config.api}/configuration`, payload)
